/**
 * @generated SignedSource<<fe763b981d8c7daa59bf0418183a1dc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageDefinitionPages_MessageDefinitionFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MessageDefinitionPagesOrderList_MessageDefinitionFragment">;
  readonly " $fragmentType": "MessageDefinitionPages_MessageDefinitionFragment";
};
export type MessageDefinitionPages_MessageDefinitionFragment$key = {
  readonly " $data"?: MessageDefinitionPages_MessageDefinitionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MessageDefinitionPages_MessageDefinitionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageDefinitionPages_MessageDefinitionFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MessageDefinitionPagesOrderList_MessageDefinitionFragment"
    }
  ],
  "type": "MessageDefinition",
  "abstractKey": null
};

(node as any).hash = "b0447cd8546c450369fcb01f3e5610d3";

export default node;
